(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lm2-scene"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lm-scene')) customElements.define('lm-scene', class extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.video.muted = true;
    this.video.defaultMuted = true;
    this.video.playsInline = true;
    this.visible = false;
    this.pending = false;
    this.autoplayBlocked = false;
    this.media = matchMedia('(prefers-reduced-motion: reduce)');
    this.shouldPlay = () => this.isConnected && this.visible && !document.hidden &&
      document.documentElement.dataset.lmMotion !== 'off' && !this.media.matches && !navigator.connection?.saveData;
    this.stop = () => {
      this.video.pause();
      this.removeAttribute('data-playing');
    };
    this.update = () => {
      if (!this.shouldPlay()) {
        this.stop();
        return;
      }
      if (this.pending || !this.video.paused) return;
      this.video.muted = true;
      if (!this.video.src) this.video.src = this.video.dataset.src;
      this.pending = true;
      this.video.play().then(() => {
        this.autoplayBlocked = false;
        if (!this.shouldPlay()) this.stop();
      }).catch(error => {
        this.autoplayBlocked = error.name === 'NotAllowedError';
        this.removeAttribute('data-playing');
      }).finally(() => { this.pending = false; });
    };
    this.onPlaying = () => {
      if (this.shouldPlay()) {
        this.autoplayBlocked = false;
        this.setAttribute('data-playing', '');
      } else this.stop();
    };
    this.onPause = () => this.removeAttribute('data-playing');
    this.onInteraction = () => { if (this.autoplayBlocked) this.update(); };
    this.video.addEventListener('playing', this.onPlaying);
    this.video.addEventListener('pause', this.onPause);
    this.observer = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
      this.update();
    }, { threshold: [0, .15] });
    this.observer.observe(this);
    document.addEventListener('visibilitychange', this.update);
    document.addEventListener('lm:motion', this.update);
    document.addEventListener('pointerup', this.onInteraction, { passive: true });
    document.addEventListener('touchend', this.onInteraction, { passive: true });
    document.addEventListener('keydown', this.onInteraction);
    window.addEventListener('pageshow', this.update);
    this.media.addEventListener('change', this.update);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    document.removeEventListener('visibilitychange', this.update);
    document.removeEventListener('lm:motion', this.update);
    document.removeEventListener('pointerup', this.onInteraction);
    document.removeEventListener('touchend', this.onInteraction);
    document.removeEventListener('keydown', this.onInteraction);
    window.removeEventListener('pageshow', this.update);
    this.media?.removeEventListener('change', this.update);
    this.video?.removeEventListener('playing', this.onPlaying);
    this.video?.removeEventListener('pause', this.onPause);
    this.stop?.();
  }
});
  } catch(e) { console.error(e); }
})();

})();
